import React, { FC } from 'react'
import CancelInformation from './CancelInformation'
import { ScrollDimModal } from '~/app/components'
import { useRouter } from 'next/router'
import { InformationFormat } from '~/app/components/order-list/details/InformationPanel'
import { OrderDetailsCancellationCategoryOrders } from '~/app/components/order-list/hooks/useCancelInfo'
import { CancelCause } from '~/__generated__/__types__'

/**
 * CancelInformationModal component
 * author: soojin.oh
 */

// type definitions
type Props = {
  title: string
  isOpened: boolean
  information: InformationFormat[]
  categoryOrders?: OrderDetailsCancellationCategoryOrders
  cancelReasonCode: string
  cancelReasonDetail: string
  cancelCause?: CancelCause
  cancelReasonCodeName: string
}

const TARGET_ID = 'cancel-information'
// CancelInformationModal component
const CancelInformationModal: FC<Props> = function ({ isOpened, title, information, ...props }) {
  const { back } = useRouter()

  return (
    <ScrollDimModal isOpened={isOpened} targetId={TARGET_ID}>
      <CancelInformation
        onClickBack={back}
        date={title}
        cancelInformation={information}
        {...props}
      />
    </ScrollDimModal>
  )
}

export default CancelInformationModal
